import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostPassiveAggressiveTextsID() {
  const articleData = {
    title: 'Panduan Utama Teks Pasif-Agresif',
    description: 'Bingung dengan teks yang membuat Anda frustrasi atau kesal? Pelajari cara mengenali pesan pasif-agresif dengan deteksi bertenaga AI dari Toxic Detector.',
    slug: 'ultimate-guide-passive-aggressive-texts',
    publishDate: '2025-05-22',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa itu teks pasif-agresif?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Teks yang menyampaikan permusuhan, kritik, atau frustrasi secara tidak langsung, seringkali membuat penerima bingung atau kesal.'
      }
    }, {
      '@type': 'Question',
      name: 'Mengapa orang mengirim pesan pasif-agresif?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ini sering kali merupakan cara terselubung untuk mengekspresikan kemarahan, membuat rasa bersalah, atau memanipulasi tanpa konfrontasi terbuka.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah AI mendeteksi perilaku pasif-agresif dalam pesan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Toxic Detector menganalisis nada, frasa, penggunaan emoji, pola respons, dan sarkasme halus untuk menandai teks manipulatif.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/id/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Panduan Utama Teks Pasif-Agresif — Bagaimana AI Mendeteksi Manipulasi | ToxicDetector" description="Bingung dengan teks yang membuat Anda frustrasi? Pelajari cara mengenali pesan pasif-agresif dengan AI." keywords="teks pasif-agresif, perilaku pasif-agresif terselubung, pola manipulasi teks, detektor agresi pasif AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/rgRp5kcuKrQdAWFQxfbcKt/file_0000000085487243beb3c848ebc5ef15.png" schema={[faqSchema, articleSchema]} data-id="element-7156" />
      <div className="flex flex-col w-full min-h-screen bg-[#fafaf9]" data-id="element-7157">
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm bg-white/95" data-id="element-7158">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-7159">
            <div className="flex items-center justify-between" data-id="element-7160">
              <Link to="/" className="text-2xl font-bold tracking-tight" data-id="element-7161">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-7162">
                <Share2 size={20} data-id="element-7163" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-12" data-id="element-7164">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors" data-id="element-7165">
            <ArrowLeft size={16} className="mr-2" data-id="element-7166" />
            Kembali ke Beranda
          </Link>

          <header className="mb-12" data-id="element-7167">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-7168">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7169">
              <time dateTime={articleData.publishDate} data-id="element-7170">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7171">•</span>
              <span data-id="element-7172">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-7173">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg" alt="AI menganalisis pesan teks pasif-agresif" className="w-full rounded-2xl shadow-lg" data-id="element-7174" />
          </div>

          <div className="bg-white rounded-2xl p-7 border border-gray-200 mb-12" data-id="element-7175">
            <h2 className="font-bold text-lg mb-5" data-id="element-7176">Daftar Isi</h2>
            <ol className="space-y-3 text-sm list-decimal list-inside" data-id="element-7177">
              <li data-id="element-7178">
                <a href="#sure-whatever" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7179">
                  Klasik "Tentu, Terserah"
                </a>
              </li>
              <li data-id="element-7180">
                <a href="#backhanded-compliment" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7181">
                  Pujian Tidak Tulus
                </a>
              </li>
              <li data-id="element-7182">
                <a href="#friendly-reminder" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7183">
                  "Pengingat Ramah" yang Sebenarnya Sindiran
                </a>
              </li>
              <li data-id="element-7184">
                <a href="#ghostly-reply" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7185">
                  Balasan Hantu
                </a>
              </li>
              <li data-id="element-7186">
                <a href="#sarcasm-humor" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7187">
                  Sarkasme yang Disamarkan sebagai Humor
                </a>
              </li>
              <li data-id="element-7188">
                <a href="#conditional-niceness" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7189">
                  Kebaikan Bersyarat
                </a>
              </li>
              <li data-id="element-7190">
                <a href="#rollercoaster" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7191">
                  Rollercoaster Bolak-Balik
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg prose-gray max-w-none" data-id="element-7192">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7193">
              Pernah menerima teks yang membuat Anda mempertanyakan apakah Anda
              bereaksi berlebihan — meskipun itu membuat Anda kesal, frustrasi,
              atau bingung? Itu adalah <strong data-id="element-7194">teks pasif-agresif</strong> yang
              sedang beraksi.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-7195">
              <strong data-id="element-7196">Deteksi AI</strong> kami dapat menangkap pola{' '}
              <strong data-id="element-7197">perilaku manipulatif</strong> ini secara instan. Berikut
              adalah panduan utama Anda.
            </p>

            <section id="sure-whatever" className="mb-12" data-id="element-7198">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7199">
                1️⃣ Klasik "Tentu, Terserah"
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7200">
                <p className="italic text-gray-700 text-lg" data-id="element-7201">
                  "Tentu, apa pun yang membuatmu bahagia..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7202">
                Sekilas, ini tampak setuju—tetapi di bawahnya? Penolakan atau
                sarkasme. AI menandai frasa ini.
              </p>
            </section>

            <section id="backhanded-compliment" className="mb-12" data-id="element-7203">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7204">
                2️⃣ Pujian Tidak Tulus
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7205">
                <p className="italic text-gray-700 text-lg" data-id="element-7206">
                  "Wow, kamu benar-benar melakukan itu... bagus untukmu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7207">
                Terdengar bagus? Tidak juga. Sindiran terselubung seperti ini
                merusak kepercayaan diri Anda.
              </p>
            </section>

            <section id="friendly-reminder" className="mb-12" data-id="element-7208">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7209">
                3️⃣ "Pengingat Ramah" yang Sebenarnya Sindiran
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7210">
                <p className="italic text-gray-700 text-lg" data-id="element-7211">
                  "Hanya supaya kamu tahu... aku membersihkan seluruh dapur."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7212">
                Teks pasif-agresif sering menyamarkan kritik sebagai info yang
                bermanfaat.
              </p>
            </section>

            <section id="ghostly-reply" className="mb-12" data-id="element-7213">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7214">
                4️⃣ Balasan Hantu
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7215">
                <p className="italic text-gray-700 text-lg" data-id="element-7216">
                  "K..." atau tidak ada balasan sama sekali
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7217">
                Respons singkat, tertunda, atau hilang dapat menghukum tanpa
                konfrontasi.
              </p>
            </section>

            <section id="sarcasm-humor" className="mb-12" data-id="element-7218">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7219">
                5️⃣ Sarkasme yang Disamarkan sebagai Humor
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7220">
                <p className="italic text-gray-700 text-lg" data-id="element-7221">
                  "Oh, kamu sangat pintar 😏"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7222">
                Sarkasme terselubung adalah alat utama. AI kami menangkap
                konteksnya.
              </p>
            </section>

            <section id="conditional-niceness" className="mb-12" data-id="element-7223">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7224">
                6️⃣ Kebaikan Bersyarat
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7225">
                <p className="italic text-gray-700 text-lg" data-id="element-7226">
                  "Aku akan membantu... jika aku tidak punya rencana."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7227">
                Orang pasif-agresif menetapkan batasan untuk membuat rasa
                bersalah.
              </p>
            </section>

            <section id="rollercoaster" className="mb-12" data-id="element-7228">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7229">
                7️⃣ Rollercoaster Bolak-Balik
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7230">
                <p className="italic text-gray-700 text-lg" data-id="element-7231">
                  Tinggi dan rendah yang ekstrem dalam teks
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7232">
                Nada yang berfluktuasi adalah tanda bahaya untuk perilaku
                manipulatif.
              </p>
            </section>

            <section className="mb-12" data-id="element-7233">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7234">
                🛡 Cara Melindungi Diri Sendiri
              </h2>
              <ul className="space-y-4 text-lg text-gray-600" data-id="element-7235">
                <li className="flex items-start gap-3" data-id="element-7236">
                  <span className="text-gray-900 font-bold" data-id="element-7237">•</span>
                  <span data-id="element-7238">Percayai insting Anda.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-7239">
                  <span className="text-gray-900 font-bold" data-id="element-7240">•</span>
                  <span data-id="element-7241">Simpan tangkapan layar.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-7242">
                  <span className="text-gray-900 font-bold" data-id="element-7243">•</span>
                  <span data-id="element-7244">Hindari menganalisis teks secara berlebihan.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-7245">
                  <span className="text-gray-900 font-bold" data-id="element-7246">•</span>
                  <span data-id="element-7247">Gunakan Toxic Detector.</span>
                </li>
              </ul>
            </section>

            <section className="mb-16" data-id="element-7248">
              <h2 className="text-3xl font-bold mb-8 tracking-tight" data-id="element-7249">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-6" data-id="element-7250">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-7251">
                    <h3 className="font-bold text-lg mb-3 text-gray-900" data-id="element-7252">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-7253">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-gray-900 rounded-2xl p-12 text-center text-white mt-16" data-id="element-7254">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7255">
              💀 Berhenti Menerjemahkan. Mulai Mengetahui.
            </h2>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7256">
              Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
              skor toksisitas instan.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-7257">
              <p className="font-bold text-xl" data-id="element-7258">
                "🚩 65% agresi pasif terdeteksi — perilaku meremehkan berulang
                ditemukan!"
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-gray-900 px-10 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors" data-id="element-7259">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Apakah Mantan Anda Narsisis Terselubung?',
          description: 'Temukan jika mantan Anda menunjukkan tanda-tanda perilaku narsisis terselubung dalam teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }, {
          title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
          description: 'Pahami pola narsisme dan gaslighting dalam hubungan.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }]} data-id="element-7260" />

          <div className="mt-12 text-center" data-id="element-7261">
            <button onClick={handleShare} className="inline-flex items-center text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-7262">
              <Share2 size={18} className="mr-2" data-id="element-7263" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-12 mt-16" data-id="element-7264">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7265">
            <p className="text-gray-400 text-sm" data-id="element-7266">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </>;
}